import 'swiper/css'
import 'swiper/css/effect-creative'

import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, EffectCoverflow } from "swiper/modules"
import { new3DSlider } from './NewAwardSection'
import { AnimatePresence, motion } from 'framer-motion'
import { captions } from './NewAwardSection'
import { useState } from 'react'

const MAX_IMAGE_RETRIES = 3

const SlideImage = ({ src, alt }) => {
    const [retryKey, setRetryKey] = useState(0)

    const handleError = () => {
        if (retryKey < MAX_IMAGE_RETRIES) {
            setRetryKey((prev) => prev + 1)
        }
    }

    return (
        <img
            key={retryKey}
            src={retryKey > 0 ? `${src}${src.includes('?') ? '&' : '?'}retry=${retryKey}` : src}
            alt={alt}
            onError={handleError}
            className="rounded-2xl md:rounded-3xl w-full h-auto object-cover shadow-[0_-10px_12px_rgba(66,133,244,0.3)]"
        />
    )
}

const ThreeDSlider = () => {

    const [ currentIndex, setCurrentIndex ] = useState(0)

    return (
        <div>
            <div className='px-[22px] h-16 md:h-16 relative mt-2 flex justify-center'>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className='text-[16px] absolute text-[#D5EDFF] font-medium text-center md:text-[18px]'
                    >
                        ✨ {captions[currentIndex]}
                    </motion.div>
                </AnimatePresence>
            </div>
            <div 
                className=""
            >
                <Swiper
                    modules={[Autoplay, EffectCoverflow]}
                    effect="coverflow"
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    loop={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    onSlideChange={(swiper) => {
                        setCurrentIndex(swiper.realIndex % captions.length);
                    }}
                    speed={1000}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2.5,
                        slideShadows: false,
                    }}
                    className="mySwiper"
                >
                    {new3DSlider.map((src, index) => (
                        <SwiperSlide key={index} className="">
                            <SlideImage
                                src={src}
                                alt={`Slide ${index}`}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default ThreeDSlider
